import Cookies from "js-cookie";
import { User } from "../types/UserData";
import { UserGQLSCHEMA } from "./gql/User";
import { gqlRequest } from "./functions";
import { USER_URL } from "./env";
export const setAuthentication = (token: string, remember?: boolean) =>
  remember
    ? Cookies.set("Time4DataCenterauthToken", token, { expires: 356 })
    : Cookies.set("Time4DataCenterauthToken", token, { expires: 1 });
export const getAuthentication = () => {
  const token = Cookies.get("Time4DataCenterauthToken");
  return token || null;
};
export const removeAuthentication = () =>
  Cookies.remove("Time4DataCenterauthToken");

export const getUserData = async (token: string): Promise<User | null> => {
  const gqlString = `query {
    GetUserInfo {
      ${UserGQLSCHEMA}
    }
  }`;

  try {
    const response = await gqlRequest<{ GetUserInfo: User }>({
      query: gqlString,
      endpoint: USER_URL,
      headers: {
        authorization: `Bearer ${token}`,
      },
    });

    if (response.errors && response.errors.length > 0) {
      return null;
    }

    return response.data?.GetUserInfo || null;
  } catch (err: unknown) {
    throw err;
  }
};
